module.exports = __webpack_public_path__ + "img/logo_blue.c48de2b2.png";